import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { API_URL } from '../Actions/Config'
import AOS from "aos";
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'
import TourListing from "./Common/TourListing"
import ThinRentListing from "./ListPage/ThinRentListing"
import { getSearchResult } from "../Actions/HomeAction"
import "aos/dist/aos.css";

const mapStateToProps = (state) => {
    return {
        tour: state.Tour
    }
}

const mapDispatchToProps = dispatch => ({
    getSearchResult: (loc, id) => dispatch(getSearchResult(loc, id))
});

function getURL(tour) {
    var url = ""
    switch (tour.tour) {
        case "Day tour":
            url = "/day-tours/" + tour.permalink + "/" + tour.id
            break;
        case "Round tour":
            url = "/round-tours/" + tour.itinerary_category.name.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '') + "/" + tour.permalink
            break;

        case "Excursion":
            url = "/things-to-do/" + tour.permalink
            break;

        case "Rent Vehicle":
            url = "/transport/" + tour.permalink
            break;

        default:
            break;
    }
    return url
}


function getBackgroudImage(tour) {
    var image = ""
    switch (tour.tour) {
        case "Day tour":
            image = tour.listing_image != undefined && tour.listing_image != '' ? tour.listing_image : API_URL + tour.banner_image
            break;
        case "Round tour":
            image = tour.home_image != undefined && tour.home_image != '' ? API_URL + tour.home_image : API_URL + tour.itinerary_images.thumb
            break;
        case "Maldive tour":
            image = tour.home_image.thumb
            break;
        case "Excursion":
            image = API_URL + "/" + tour.image
            break;
        case "Rent Vehicle":
            image = API_URL + "/" + tour.package_thumbnail
            break;
        default:
            break;
    }
    return image
}

class SearchResultPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loc: false,
            id: ""
        }
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search);

        const location = params.get("location")
        const id = params.get("id")

        this.props.getSearchResult(location, id)

        AOS.init({
            duration: 800,
            once: true
        });
    }

    render() {

        return <Fragment>
            <Header home={false} />
            <Helmet
                title={"Tour List"}
                description={"Listing"}
            />

            <div className="page-title">
                <div className="container title-cont">
                    <div className="row">
                        <div className="col-lg-12 title-inner">
                            <h1 id="tour-title">Search Results</h1>
                        </div>
                    </div>
                </div>
            </div>
            <div id="loadDayTour" style={{ backgroundColor: "#f8f8f8", minHeight: "20vh" }}>


                {this.props.tour.dayTours.length > 0 ?
                    <div id="myDiv">
                        <div className="maindiv" >
                            <div className="container">
                                <h2 style={{ fontSize: 30, color: "#175480", fontWeight: 600, margin: "0 0 15px 15px;", paddingTop: 15 }}> Day Tours </h2>
                                <a href="/day-tours" className='hombtn showmore cardbtn'>Show more</a>
                                <div className='clear' />
                                <div className="row day-tour-row">

                                    {this.props.tour.dayTours.map((tour, index) => (<TourListing
                                        {...this.props}
                                        index={index}
                                        url={getURL(tour)}
                                        bgImage={getBackgroudImage(tour)}
                                        tour={tour}
                                        key={index + 1}
                                    />))}

                                </div>
                            </div>
                        </div>
                    </div> : null}

                {this.props.tour.roundTours.length > 0 ?
                    <div id="myDiv">
                        <div className="maindiv" >
                            <div className="container">
                                <h2 style={{ fontSize: 30, color: "#175480", fontWeight: 600, margin: "0 0 15px 15px;", paddingTop: 15 }}> Round Tours </h2>
                                <a href="/round-tours" className='hombtn showmore cardbtn'>Show more</a>
                                <div className='clear' />
                                <div className="row day-tour-row">

                                    {this.props.tour.roundTours.map((tour, index) => (<TourListing
                                        {...this.props}
                                        index={index}
                                        url={getURL(tour)}
                                        bgImage={getBackgroudImage(tour)}
                                        tour={tour}
                                        key={index + 1}
                                    />))}

                                </div>
                            </div>
                        </div>
                    </div> : null}

                {this.props.tour.excursions.length > 0 ?
                    <div id="myDiv">
                        <div className="maindiv" >
                            <div className="container">
                                <h2 style={{ fontSize: 30, color: "#175480", fontWeight: 600, margin: "0 0 15px 15px;", paddingTop: 15 }}> Things You Can Do </h2>
                                <a href="/things-to-do" className='hombtn showmore cardbtn'>Show more</a>
                                <div className='clear' />
                                <div className="row day-tour-row">
                                    {this.props.tour.excursions.map((tour, index) => (<ThinRentListing
                                        {...this.props}
                                        key={index}
                                        index={index}
                                        url={getURL(tour)}
                                        bgImage={getBackgroudImage(tour)}
                                        tour={tour}
                                    />))}
                                </div>
                            </div>
                        </div>
                    </div> : null}

                {this.props.tour.rentVehicle.length > 0 ?
                    <div id="myDiv">
                        <div className="maindiv" >
                            <div className="container">
                                <h2 style={{ fontSize: 30, color: "#175480", fontWeight: 600, margin: "0 0 15px 15px;", paddingTop: 15 }}> Rent a Car </h2>
                                <a href="/transport" className='hombtn showmore cardbtn'>Show more</a>
                                <div className='clear' />
                                <div className="row day-tour-row">
                                    {this.props.tour.rentVehicle.map((tour, index) => (<ThinRentListing
                                        {...this.props}
                                        key={index}
                                        index={index}
                                        url={getURL(tour)}
                                        bgImage={getBackgroudImage(tour)}
                                        tour={tour}
                                    />))}

                                </div>
                            </div>
                        </div>
                    </div> : null}
            </div>

            <Footer hyperLink={true} />
        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(SearchResultPage);